const NULL_LISTENER = [
  /Cannot read properties of null \(reading 'addEventListener'\)/,
  /Cannot read property ['"]addEventListener['"] of null/,
  /null is not an object \(evaluating ['"`]?.+\.addEventListener['"`]?\)/,
  // Firefox (RENTRUNNER-FRONTEND-HW on return-locations)
  /can't access property ['"]addEventListener['"], .+ is null/
];

const THIRD_PARTY = [
  /maps\.googleapis\.com/i,
  /maps-api-v3/i,
  /consent\.cookiebot\.com/i,
  /\/uc\.js/i,
  /rocket-loader/i
];

const messageOf = value => {
  if (value == null) return "";
  if (typeof value === "string") return value;
  return String(value.message || "");
};

const stackOf = (value, extraStack) =>
  [extraStack, value && typeof value === "object" ? value.stack : ""]
    .filter(Boolean)
    .join("\n");

export const isGoogleMapsNullListenerError = (value, extraStack) => {
  const message = messageOf(value);
  if (!NULL_LISTENER.some(pattern => pattern.test(message))) return false;

  const stack = stackOf(value, extraStack);
  if (!stack) return false;

  return THIRD_PARTY.some(pattern => pattern.test(stack));
};
